package br.com.texeratx.boardgametimeapp.data.model.login

import kotlinx.serialization.Serializable

@Serializable
data class UserSession(
    val token: String,
    val userId: Long,
    val email: String,
    val displayName: String,
    val userImageUrl: String? = null,
    val activeClanId: Long? = null,
    val activeClanName: String? = null,
    val activeClanImageUrl: String? = null,
    val activeRole: String? = null
)
